export default "__VITE_ASSET__8jdHxSSK__"